/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { observer } from 'mobx-react';
import { useStores } from 'hooks/use-stores';
import { useItemSheet } from 'hooks/use-item-sheet';
import * as React from 'react';
import { useOpenItemSheet } from 'hooks/use-open-item-sheet';
import { useHistory } from 'react-router-dom';
import MenuItem from 'models/MenuItem';
import {
  CarouselIcon,
  CarouselItemName,
  CarouselItemNameWrapper,
  CarouselItemPrice,
  RecommendationCard,
} from './recommendationStyles';
import EmptyIcon from './EmptyIcon';
import Stepper from './Stepper';
import { getConstsForRecommendation } from './utils';

interface RecommendationType {
  item: MenuItem;
  menuId: string;
  referringItem?: MenuItem;
  fromCart?: boolean;
  mostLoved?: boolean;
}

function Recommendation({ item, menuId, referringItem, fromCart, mostLoved = false }: RecommendationType) {
  const {
    menuDataStore,
    checkoutStore: { selectedCart },
    rootStore,
    userStore: { anonymousUserId },
  } = useStores();
  const history = useHistory();
  const { name_for_customer = '', displayPrice = '', imageUrl = '' } = item;
  const { getLinkToAddItem } = useOpenItemSheet();

  const { itemInCart, pushCartItem, imgSrc, newCartItem } = getConstsForRecommendation(
    selectedCart,
    useItemSheet,
    history,
    getLinkToAddItem,
    imageUrl,
    rootStore,
    anonymousUserId,
    menuId,
    item.id,
    mostLoved,
    menuDataStore
  );

  const [visible, setVisible] = React.useState(!(fromCart && itemInCart));

  React.useEffect(() => {
    if (mostLoved && itemInCart) {
      setTimeout(() => {
        const itemList = document.getElementById('cart-items-list');
        itemList?.scrollIntoView(false);
        setVisible(false);
      }, 400);
    }
  }, [mostLoved, itemInCart]);

  return !visible ? null : (
    <RecommendationCard visible={!(fromCart && itemInCart)}>
      <span onClick={() => pushCartItem(newCartItem)}>
        {imageUrl ? (
          <CarouselIcon src={imgSrc} alt={name_for_customer} />
        ) : (
          <EmptyIcon aria-label={name_for_customer} />
        )}
      </span>
      {!mostLoved && (
        <Stepper
          itemId={item.id}
          adjustPadding={false}
          newCartItem={newCartItem}
          pushCartItem={pushCartItem}
          itemInCart={itemInCart}
          referringItem={referringItem}
          selectedCart={selectedCart}
          setVisible={setVisible}
          fromCart={fromCart ?? false}
        />
      )}
      <span onClick={() => pushCartItem(newCartItem)}>
        <CarouselItemNameWrapper>
          <CarouselItemName>{name_for_customer}</CarouselItemName>
        </CarouselItemNameWrapper>
        <CarouselItemPrice>{displayPrice}</CarouselItemPrice>
      </span>
    </RecommendationCard>
  );
}

export default observer(Recommendation);
